<template>
  <div id="banner-search">
    <div class="box">
      <h2 class="slogan">查标讯,上采讯</h2>
      <p class="slogan-desc">免费查看全国标讯信息</p>
      <div class="search">
        <div class="search-wrap">
          <app-icon type="iconsousuo" />
          <a-input-search
            placeholder="请输入您要查询标讯的关键字"
            :value="searchText"
            @change="onChange"
            @search="onSearch"
            enterButton="搜索"
          />
        </div>
        <div class="hot-links">
          <span class="hot-item"  v-for="(item, index) in hotLinks" :key="index">
            <a @click="onClickSearchText(item)" >{{ item }}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from '@/components/icon';
export default {
  name: 'search-banner',
  components: {
    'app-icon': AppIcon
  },
  data () {
    return {
      text: this.searchText,
      hotLinks: [
        '电梯',
        '雕塑',
        '泵',
        '景观',
        '阀门'
      ]
    };
  },
  props: {
    handleSearch: {
      type: Function,
      default: function () {}
    },
    searchText: {
      type: String,
      default: () => ''
    },
    onSerachChange: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onChange (e) {
      this.onSerachChange(e.target.value);
    },
    onSearch (text) {
      const searchText = typeof text === 'undefined' ? this.searchText : text;
      if (searchText.trim() === '') {
        return false;
      }
      this.handleSearch(searchText);
    },
    onClickSearchText (text) {
      this.onSerachChange(text);
      this.onSearch(text);
    }
  }
};
</script>

<style lang="less">
  #banner-search {
    width: 100%;
    height: 360px;
    padding-top: 207px;
    background: url(https://sitecdn.zcycdn.com/zcy-front-other-upload/e471cc5d02076c481511ee6e09e49f06.png) no-repeat top center #197AFF;
    background-size: 1200px 360px;
    .box {
      width: 633px;
      margin: 0 auto;
      .slogan {
        font-size: 38px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        display: none;
      }
      .slogan-desc {
        text-align: center;
        font-size: 18px;
        color: #fff;
        margin-bottom: 20px;
        display: none;
      }
      .search-wrap {
        position: relative;
        .anticon {
          position: absolute;
          top: 16px;
          left: 20px;
          color: #9B9B9B;
          font-size: 14px;
          z-index: 100;
        }
      }
      .ant-input {
        height: 46px;
        padding: 11px 46px 11px 45px;
        border: none;
        border-radius: 2px;
      }
      .ant-btn {
        width: 72px;
        height: 46px;
        background: #00C7FF;
        border-radius: 0 2px 2px 0;
        border: none;
        font-size: 16px;
        letter-spacing: -2px;
        transition: all linear 0.5s;
        text-shadow: none;
        &:hover {
          background-color: #00BBEF;
        }
      }
      .hot-links {
        height: 18px;
        margin-top: 11px;
        padding-left: 56px;
        text-align: left;
        font-size: 12px;
        background: url(https://sitecdn.zcycdn.com/zcy-front-other-upload/3048533fae8cae13fe17708c5cab9eca.png) no-repeat left center;
        background-size: 45px 18px;
        .hot-item {
          float: left;
          position: relative;
          padding: 0 10px;
          a {
            color: #fff;
            &:hover {
              color: #fff;
              text-decoration: underline;
            }
          }
          &:after {
            content: '';
            display: block;
            position: absolute;
            top: 4px;
            right: 0;
            width: 1px;
            height: 10px;
            background: #5AA0FF;
          }
          &:last-child {
            &:after {
              display: none;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/search.vue